import { useAPICallAsQuery, useAPICallAsMutation } from '@/service/hooks';
import { getReferralAgreements, getReferrals, getReferralSummary, createReferral, checkReferral } from './api';
import { ICheckReferralPayload, ICreateReferralPayload } from './types';
import { UseMutationOptions } from 'react-query';

export function useReferralAgreements() {
  return useAPICallAsQuery('referral-agreements', getReferralAgreements, undefined as any);
}

export function useReferrals(search?: string) {
  return useAPICallAsQuery('referrals', getReferrals, { search });
}

export function useReferralSummary() {
  return useAPICallAsQuery('referral-summary', getReferralSummary, undefined as any);
}

export function useCreateReferral(options: UseMutationOptions<any, any, ICreateReferralPayload, any> = {}) {
  return useAPICallAsMutation(createReferral, options);
}

export function useCheckReferral(options: UseMutationOptions<any, any, ICheckReferralPayload, any> = {}) {
  return useAPICallAsMutation(checkReferral, options);
}
